import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    getReportStatus:"idle",
    error:"",
    getReportData:{},
    getAllReportStatus:"idle",
    getAllReportData:{},
    getIdiqReportData:{},
    getIdiqReportStatus:"idle",
    getRoundStatus:"idle",
    getRoundData:{},
    reportEmailData:{},
    reportEmailstatus:"idle"
}

export const getReportContent = createAsyncThunk('reports/getReportContent',async (initalContent)=>{
    let formData = new FormData();
    let accessToken = localStorage.getItem('accessToken');
    formData.append("Token",accessToken);
    formData.append("client_id",btoa(initalContent.client_id));
    formData.append("round",1);
    formData.append("sourcecodearea",`${initalContent.report_content}`);
    formData.append("reportType",initalContent.report_type);
    let response = await axios.post('form/checkReportedName',formData);
    if (response.status === 200) {
        return response.data
    }else{
        throw new Error(response.statusText)
    }
    
})

export const getAllReport = createAsyncThunk('reports/getAllReports',async (initialData)=>{
    let url = `clientportal/getReportData/${initialData.clientId}/${initialData.company_id}/${initialData.roundid}`;
    let response = await axios.get(url);
    if (response.status === 200) {
        return response.data
        // return dataJson;
    }else{
        throw new Error(response.statusText)
    }
})

export const getIdiqReport = createAsyncThunk('report/getIdiqReport', async (initalContent)=>{
    let formData = new FormData();
    let accessToken = localStorage.getItem('accessToken');
    formData.append("Token",accessToken);
    formData.append("client_id",btoa(initalContent.id));
    formData.append("docupload",initalContent.file);
    formData.append("provider_type","IdentityIQ");
    let response = await axios.post('form/getReportPdfToJson',formData);
    if (response.status === 200) {
        return response.data
        // return dataIdiqJson;
    }else{
        throw new Error(response.statusText)
    }
    // return dataIdiqJson;
})

export const getIdiqReportLogin = createAsyncThunk('report/getIdiqReportLogin', async (initalContent)=>{
    let formData = new FormData();
    let accessToken = localStorage.getItem('accessToken');
    formData.append("Token",accessToken);
    formData.append("client_id",btoa(initalContent.id));
    formData.append("round",1);
    formData.append("reportType",initalContent.report_type);
    formData.append("username",initalContent.username);
    formData.append("password",initalContent.password);
    formData.append("last4ofsocial",initalContent.ssn);
    let response = await axios.post('form/GetReportUploaderDataDisputeForm',formData);
    if (response.status === 200) {
        return response.data
        // return dataIdiqJson;
    }else{
        throw new Error(response.statusText)
    }
    // return dataIdiqJson;
})

export const getRounds = createAsyncThunk('reports/getRounds',async (initalContent)=>{
    let url = `clientportal/getReportsList/${initalContent.clientId}/${initalContent.company_id}`
    let response = await axios.get(url);
    if (response.status === 200) {
        return response.data
        // return dataJson;
    }else{
        throw new Error(response.statusText)
    }
})

export const getReportWithEmail = createAsyncThunk('reports/getReportEmail', async (initalContent)=>{
    let formData = new FormData();
    formData.append("company_id",initalContent.company_id);
    formData.append("client_id",initalContent.clientId);
    formData.append("email",initalContent.email);
    let response = await axios.post('clientportal/checkClientEmail',formData);
    if (response.status === 200) {
        return response.data
        // return dataJson;
    }else{
        throw new Error(response.statusText)
    }
})

const ReportSlice = createSlice({
    name:'reports',
    initialState,
    reducers:{
        blankGetReportData:(state) => {
            state.getReportData = {}
            state.getReportStatus = "idle"
        },
        blankIdiqReport:(state) => {
            state.getIdiqReportData = {};
            state.getIdiqReportStatus = "idle"
        },
        blankIdiqReportLogin:(state) => {
            state.getIdiqLoginReport = {};
            state.getIdiqLoginStatus = "idle"
        },
        blankGetAllReportData:(state) => {
            state.getAllReportStatus="idle";
            state.getAllReportData={}
        },
        setReportUploaded:(state,action)=>{
            state.isReportUploaded = action.payload;
        },
        blankGetRounds:(state) => {
            state.getRoundStatus="idle";
            state.getRoundData = {};
        },
        blankReportEmail:(state)=>{
            state.reportEmailData = {};
            state.reportEmailstatus = "idle"
        }
    },
    extraReducers:(builder) => {
        builder.addCase(getReportContent.pending,(state)=>{
            state.getReportStatus = "loading";
        })
        builder.addCase(getReportContent.fulfilled,(state,action)=>{
            state.getReportStatus = "succeeded"
            state.error = '';
            state.getReportData = action.payload;
        })
        builder.addCase(getReportContent.rejected,(state,action) => {
            state.getReportStatus = "falied";
            state.error = action.error.message;
            state.getReportData = {};
        })
        builder.addCase(getAllReport.pending,(state)=>{
            state.getAllReportStatus = "loading";
        })
        builder.addCase(getAllReport.fulfilled,(state,action)=>{
            state.getAllReportStatus = "succeeded"
            state.error = '';
            state.getAllReportData = action.payload;
        })
        builder.addCase(getAllReport.rejected,(state,action) => {
            state.getAllReportStatus = "falied";
            state.error = action.error.message;
            state.getAllReportData = {};
        })
        builder.addCase(getIdiqReport.pending,(state)=>{
            state.getIdiqReportStatus = "loading";
        })
        builder.addCase(getIdiqReport.fulfilled,(state,action)=>{
            state.getIdiqReportStatus = "succeeded"
            state.error = '';
            state.getIdiqReportData = action.payload;
        })
        builder.addCase(getIdiqReport.rejected,(state,action) => {
            state.getIdiqReportStatus = "falied";
            state.error = action.error.message;
            state.getIdiqReportData = {};
        })
        builder.addCase(getIdiqReportLogin.pending,(state)=>{
            state.getIdiqLoginStatus = "loading";
        })
        builder.addCase(getIdiqReportLogin.fulfilled,(state,action)=>{
            state.getIdiqLoginStatus = "succeeded"
            state.error = '';
            state.getIdiqLoginReport = action.payload;
        })
        builder.addCase(getIdiqReportLogin.rejected,(state,action) => {
            state.getIdiqLoginStatus = "falied";
            state.error = action.error.message;
            state.getIdiqLoginReport = {};
        })
        builder.addCase(getRounds.pending,(state)=>{
            state.getRoundStatus = "loading";
        })
        builder.addCase(getRounds.fulfilled,(state,action)=>{
            state.getRoundStatus = "succeeded"
            state.error = '';
            state.getRoundData = action.payload;
        })
        builder.addCase(getRounds.rejected,(state,action) => {
            state.getRoundStatus = "falied";
            state.error = action.error.message;
            state.getRoundData = {};
        })
        builder.addCase(getReportWithEmail.pending,(state)=>{
            state.reportEmailstatus = "loading";
        })
        builder.addCase(getReportWithEmail.fulfilled,(state,action)=>{
            state.reportEmailstatus = "falied";
            state.reportEmailData = action.payload
        })
        builder.addCase(getReportWithEmail.rejected,(state,action) => {
            state.reportEmailstatus = "succeeded";
            state.reportEmailData = {};
        })
    }
})
export const { blankGetReportData,blankIdiqReport,blankGetAllReportData,setReportUploaded,blankGetRounds,blankIdiqReportLogin,blankReportEmail } = ReportSlice.actions;


export default ReportSlice.reducer; 